import { CampdeskLogo } from '@/components/svg/CampdeskLogo.tsx';
import React from 'react';

const BookingErrorPage = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4">
      <div className="flex flex-col items-center gap-8 text-center">
        <CampdeskLogo />

        <div className="space-y-2">
          <h2 className="text-2xl font-semibold text-base-text">
            Ten wyjazd nie istnieje
          </h2>
          <p className="text-base text-neutral-600">
            Skontaktuj się z organizatorem jeżeli uważasz że to pomyłka.
          </p>
        </div>

        <img
          src="/404.png"
          alt=""
          className="h-auto w-[400px] rounded-sm object-contain"
        />
      </div>
    </div>
  );
};

export default BookingErrorPage;
